import React from "react";
import { Text } from "@bookingcom/bui-react";
export const UnifiedPriceTagExplanation = ({ priceExplanation, priceExplanationProps, shouldShowPricePerAdult }) => {
    if (shouldShowPricePerAdult || !priceExplanation)
        return;
    return (React.createElement(Text, { variant: "small_1", color: "neutral_alt", ...priceExplanationProps }, priceExplanation));
};
